import type { ReactNode } from 'react';

export type PageStatusTone = 'ok' | 'warn' | 'danger' | 'neutral';
// Neutral status is plain text: a grey dot carries no meaning.
const DOT: Record<PageStatusTone, string | null> = {
  ok: 'bg-ok',
  warn: 'bg-warn',
  danger: 'bg-danger',
  neutral: null,
};
export function PageHeader({
  title,
  subtitle,
  actions,
  status,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  status?: { label: string; tone: PageStatusTone };
}) {
  return (
    <header className="mb-6 flex flex-col justify-between gap-4 md:flex-row md:items-center">
      <div className="min-w-0">
        <h1 className="font-display text-h1 font-semibold text-ink">{title}</h1>
        {subtitle && (
          <div className="mt-2 max-w-3xl text-body text-ink-2">{subtitle}</div>
        )}
        {status && (
          <div className="mt-2 inline-flex items-center gap-2 text-sm-label text-ink-2">
            {DOT[status.tone] && (
              <span
                aria-hidden="true"
                className={`h-1.5 w-1.5 rounded-full ${DOT[status.tone]}`}
              />
            )}
            {status.label}
          </div>
        )}
      </div>
      {actions && (
        <div className="flex min-w-0 flex-wrap items-center gap-2">
          {actions}
        </div>
      )}
    </header>
  );
}
